<template>
  <div v-if="loginPopupVisible" class="mask_1" data-io-click="tracker"  @click="closeLoginPopupVisible">
    <div class="login_popup">
      <i class="el-icon-close" />
      <!-- `https://t.zxxk.com/login?dialogTheme=true&service=https%3A%2F%2Fauth.zxxk.com%2Fuser%2Fdialogcallback%3Furl%3D${backUrl()}` -->
      <iframe
        id="dialogLoginIframe"
        allowtransparency="true"
        :src="`https://${protocolName}.zxxk.com/login?service=https://auth.zxxk.com/user/dialogcallback?url=https://wxt.xkw.com/wxtapi/auth/login?curl=https://wxt.xkw.com/soft/${documentId}-1.html&dialogTheme=true`"
        frameborder="0"
        style="
          border: 0px;
          height: 570px;
          width: 501px;
          top: calc(50% - 285px);
          left: calc(50% - 250px);
        "
        class="SSO_overlay_1653547238506popup"
      />
    </div>
  </div>
</template>
<script>
import { protocolName } from "@/utils/apis";
export default {
  props: {
    loginPopupVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      protocolName,
    };
  },
  methods: {
    closeLoginPopupVisible() {
      this.$emit("closeLoginPopupVisible");
    },
  },
};
</script>
<style lang="scss" scoped>
.mask_1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  .login_popup {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 570px;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: hidden;
    z-index: 1;
    .el-icon-close {
      position: absolute;
      right: 10px;
      cursor: pointer;
      top: 10px;
      font-size: 12px;
      color: #666;
      font-weight: bold;
      &:hover {
        color: #333;
      }
    }
  }
}
</style>
